import { createSelector } from 'reselect';
var selectFilterSelectionState = function (state) { return state.get('filterReducer'); };
export var filterSelection = createSelector(selectFilterSelectionState, function (filterState) { return filterState; });
